import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActionMenu } from "src/app/modules/models/model";

@Component({
  selector: "app-inline-table-edit",
  templateUrl: "./inline-table-edit.component.html",
  styleUrls: ["./inline-table-edit.component.scss"],
  standalone: false,
})
export class InlineTableEditComponent implements OnInit {
  constructor() {}
  @Input() value = "";
  @Input() targetId = "";
  @Input() id: string;
  @Input() action: ActionMenu = {
    name: "",
    editable: false,
    target: {},
  };
  @Input() disabled = false;
  @Output() newValue: EventEmitter<string> = new EventEmitter();

  ngOnInit(): void {}
  setData(value: string) {
    this.newValue.emit(value);
  }
}
